export const Tabs = ({tabs, activeTab, onTabChange}) => {

  return (
    <div className="w-full max-w-md">
      <div className="flex bg-gradient-to-r from-gray-50 via-white to-gray-100 rounded-xl p-1 shadow-lg border border-gray-200 gap-2 transition-all duration-300">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`flex-1 px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 ${
              activeTab === tab.id
                ? 'bg-blue-500 text-white shadow-sm'
                : 'text-gray-400 hover:text-gray-800 hover:bg-gray-200'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
}